"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ButtonConfig = /** @class */ (function () {
    function ButtonConfig(title, fieldsToLoad, searchFilter, defaultValues, searchKeywords, filterFields, columns, selectedItemFields, subFormId, hasCreateButton) {
        this._title = title;
        this.stringTitle = JSON.stringify(Array.from(title.toMap().entries()));
        this.searchFilter = searchFilter;
        this.defaultValues = defaultValues;
        this.searchKeywords = searchKeywords;
        this.filterFields = filterFields;
        this.columns = columns;
        this.selectedItemFields = selectedItemFields;
        this.subFormId = subFormId;
        this.hasCreateButton = hasCreateButton || false;
    }
    Object.defineProperty(ButtonConfig.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (value) {
            this._title = value;
            this.stringTitle = JSON.stringify(Array.from(value.toMap().entries()));
        },
        enumerable: true,
        configurable: true
    });
    return ButtonConfig;
}());
exports.ButtonConfig = ButtonConfig;
//# sourceMappingURL=button-config.js.map